import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000',
  timeout: 600000 // 10 minutes — ranking checks take time for large keyword sets
});

export const suggestKeywords = (services, businessDescription) =>
  api.post('/api/keywords/suggest', { services, businessDescription }).then(r => r.data);

export const fetchTowns = (postcode, radius) =>
  api.get('/api/locations/towns', { params: { postcode, radius } }).then(r => r.data);

export const fetchVolumes = (keywords, locationCode) =>
  api.post('/api/dataforseo/volumes', { keywords, locationCode }).then(r => r.data);

export const fetchRankings = (keywords, targetDomain, locationCode) =>
  api.post('/api/dataforseo/rankings', { keywords, targetDomain, locationCode }).then(r => r.data);

export const exportExcel = async (client, keywordGroups) => {
  const response = await api.post('/api/export/excel', { client, keywordGroups }, {
    responseType: 'blob',
    timeout: 60000
  });
  const url = URL.createObjectURL(response.data);
  const a = document.createElement('a');
  a.href = url;
  a.download = `keyword-research-${client.businessName?.replace(/\s+/g,'-').toLowerCase() || 'client'}.xlsx`;
  a.click();
  URL.revokeObjectURL(url);
};

export const writeFAQs = (questions, keyword, service, location, businessName, businessDescription, eatInfo, answerLength) =>
  api.post('/api/content/faqs', { questions, keyword, service, location, businessName, businessDescription, eatInfo, answerLength }).then(r => r.data);

export default api;

export const generateBrief = (keyword, service, location, searchVolume, rank, referenceUrl, businessName, businessDescription, eatInfo) =>
  api.post('/api/content/brief', { keyword, service, location, searchVolume, rank, referenceUrl, businessName, businessDescription, eatInfo }).then(r => r.data);

export const regenerateMeta = (keyword, businessName, currentTitle, currentDescription, regenerate) =>
  api.post('/api/content/meta', { keyword, businessName, currentTitle, currentDescription, regenerate }).then(r => r.data);

export const exportContentDoc = async (contentText, metaTitle, metaDescription, keyword, businessName, imageIdeas) => {
  const response = await api.post('/api/content/export-doc',
    { content: contentText, metaTitle, metaDescription, keyword, businessName, imageIdeas },
    { responseType: 'blob' }
  );
  const url = URL.createObjectURL(response.data);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${(keyword || 'content').replace(/\s+/g, '-').toLowerCase()}.docx`;
  a.click();
  URL.revokeObjectURL(url);
};

export const writeContent = (brief, businessName, businessDescription, referenceUrl) =>
  api.post('/api/content/write', { brief, businessName, businessDescription, referenceUrl }).then(r => r.data);
